


























import Vue from 'vue';
import Component from 'vue-class-component';
import RendezVousMedicaux from '@/components/santeEnfant/toDoList/RendezVousMedicaux.vue';
import Vaccins from '@/components/santeEnfant/toDoList/Vaccins.vue';

const Props = Vue.extend({
	props: {
		mois: {
			type: Number,
			default: 3
		}
	}
});

@Component({
	components: {
		RendezVousMedicaux,
		Vaccins
	}
})
export default class ToDoListSanteEnfant extends Props {
}
